
const NEW_BTN_HEIGHT = 24;

export const styles = (theme) => ({

  buttonContainer: {
    marginLeft: 16,
    marginRight: 'auto',
    alignSelf: 'center',
    lineHeight: `${NEW_BTN_HEIGHT}px`,
  },
  title: {
    marginTop: 'auto',
    marginBottom: 'auto',
  },
  searchContainer: {
    marginLeft: 'auto',
    marginRight: '16px',
    alignSelf: 'center',
    lineHeight: '32px',
  },
  addTxnButton: {
    marginRight: 10,
  },
  newButton: {
    padding: 0,
    height: NEW_BTN_HEIGHT,
    minHeight: NEW_BTN_HEIGHT,
    lineHeight: NEW_BTN_HEIGHT,
    marginTop: 'auto',
    marginBottom: 'auto',
    color: theme.palette.greyScale[7],
    minWidth: NEW_BTN_HEIGHT,
    // opacity: 0.8,
  },
  newButtonIcon: {
    fontSize: '20px',
    color: theme.palette.greyScale[7],
  },
  refreshButton: {
    marginRight: 20,
    padding: 0,
    height: 32,
    marginTop: 'auto',
    marginBottom: 'auto',
    fontSize: '13px',
    background: theme.palette.secondary.main,
  },
  iconButton: {
    marginRight: 1,
    color: theme.palette.greyScale[7],
  },
  scheduleMenuHolder: {
    display: 'inline-block',
  },
  iconHolder: {
    lineHeight: '5px',
    '&:hover': {
      transform: 'scale(1.1)',
      transition: 'all 0.15s ease-in-out',
    },
    '&:active': {
      transform: 'scale(1)',
      transition: 'all 0.15s ease-in-out',
    },
  },
  csvDownload: {
    marginLeft: 5,
    marginTop: 4,
    color: theme.palette.greyScale[2],

  },
  container: {
    background: theme.palette.greyScale[7],
    display: 'flex',
    height: theme.components.register.controlBarHeight,
    paddingTop: 6,
    paddingBottom: 3,
  },
  searchMetrics: {
    display: 'inline-block',
  },
  searchHelpContainer: {
    padding: 20,
    background: theme.palette.greyScale[6],
  },
  searchHelpTitle: {
    marginBottom: 2,
  },
  searchHelpSubtitle: {
    marginBottom: 3,
    marginTop: 3,
  },
  helpText: {
    marginBottom: 5,
  },
});


